export default __webpack_public_path__ + "static/media/walkawhileCropped.aca8eddd.png";